<template>
    <v-tooltip top max-width="500">
        <template v-slot:activator="{on, attrs}">
            <a v-on="on" v-bind="attrs" class="primary--text" style="text-decoration: none">
                Ver Mais
            </a>
        </template>

        <v-card flat>
            <v-card-text>
                <p class="primary--text mb-2"> <strong>Descrição completa</strong> </p>
                <p>{{ descricao | clipTextFrom(1500) }}</p>
            </v-card-text>
        </v-card>
    </v-tooltip>

</template>

<script>
export default {
    name: "VerMaisTooltip",
    props: ['descricao']
}
</script>

<style scoped lang="stylus">

</style>